import type { ResolvedTheme, ThemePreference } from 'app/types/theme'
import { logWarn } from 'lib/logging'

export const APPEARANCE_THEME_SETTING = `appearanceTheme`

// Read by the inline script in index.html before the bundle loads.
export const THEME_CACHE_KEY = `trk-theme`

const PREFERENCES: ReadonlyArray<ThemePreference> = [`light`, `dark`, `system`]

export function parseThemePreference(stored: string | undefined): ThemePreference {
  if (!stored) return `system`
  let value: unknown
  try {
    value = JSON.parse(stored)
  } catch (err) {
    logWarn(`Unreadable appearance theme setting`, err)
    return `system`
  }
  return PREFERENCES.includes(value as ThemePreference) ? (value as ThemePreference) : `system`
}

export function resolveTheme({
  toggleEnabled,
  preference,
  systemPrefersDark,
}: {
  toggleEnabled: boolean
  preference: ThemePreference
  systemPrefersDark: boolean
}): ResolvedTheme {
  if (!toggleEnabled) return `light`
  if (preference === `system`) return systemPrefersDark ? `dark` : `light`
  return preference
}
